import CoachesListContext from './CoachesListContext';

export default CoachesListContext;
export * from './withCoachesListContext';
